<template>
  <div class="page-body">
    <div v-if="(list.length === 0 && tipsType) || isLoading" class="empty-cell">
      <pageTips
        :tips-type="tipsType"
        :emptyTxt="isLoading ? '' : '还未设置爆款商品，赶快去商家端设置吧！'"
      ></pageTips>
    </div>
    <div ref="pageBody" v-if="list.length > 0" class="goods-list">
      <img class="bg-top" src="../../assets/images/goods/hot-goods-top.png" />
      <img
        class="bg-bottom"
        src="../../assets/images/goods/hot-goods-bottom.png"
      />
      <div
        v-if="list.length === 1"
        class="single-info"
        @click="goGoodsDetail(list[0].code, list[0].thumbImage)"
      >
        <div class="pic">
          <!--    crossOrigin="anonymous" -->
          <img
            :src="list[0].thumbImage + '?' + new Date().getTime()"
            crossOrigin="anonymous"
          />
        </div>
        <div class="name">
          <span>{{ list[0].name }}</span>
        </div>
        <div class="price-but">
          <div v-if="list[0].isPriceNegotiable == 1" class="price">
            价格面议
          </div>
          <div v-else class="price">
            <span
              style="
                font-size: 3.5vw;
                height: 3.5vw;
                transform: translateY(1.8vw);
              "
              >¥</span
            >
            <div style="font-size: 5.3vw">{{ list[0].price_arr.integer }}</div>
            <div style="font-size: 4.3vw; margin-top: 1vw">
              .{{ list[0].price_arr.decimals }}
            </div>
          </div>
          <div class="but">
            {{ list[0].isPriceNegotiable == 1 ? "立即询价" : "立即购买" }}
          </div>
        </div>
        <img
          class="hot-icon"
          src="../../assets/images/goods/hot-goods-icon.png"
        />
      </div>
      <div v-else class="list">
        <div
          v-for="item in list"
          :key="item.code"
          class="goods-item"
          @click="goGoodsDetail(item.code, item.thumbImage)"
        >
          <div class="pic">
            <!--          crossOrigin="anonymous" -->
            <img
              :src="item.thumbImage + '?' + new Date().getTime()"
              crossOrigin="anonymous"
            />
          </div>
          <div class="name">
            <span>{{ item.name }}</span>
          </div>
          <div v-if="item.isPriceNegotiable == 1" class="price">价格面议</div>
          <div v-else class="price">
            <span
              style="
                font-size: 3.5vw;
                height: 3.5vw;
                transform: translateY(1.8vw);
              "
              >¥</span
            >
            <div style="font-size: 5.3vw">{{ item.price_arr.integer }}</div>
            <div style="font-size: 4.3vw; margin-top: 1vw">
              .{{ item.price_arr.decimals }}
            </div>
          </div>
          <div class="but">
            {{ item.isPriceNegotiable == 1 ? "立即询价" : "立即购买" }}
          </div>
          <img
            class="hot-icon"
            src="../../assets/images/goods/hot-goods-icon.png"
          />
        </div>
      </div>
    </div>
    <!-- <div class="forwarding" @click="jumpForwarding"><span>转发</span></div> -->
  </div>
</template>

<script>
import api from "api";
import html2canvas from "html2canvas";
import utils from "@utils/index";
import wx from "weixin-js-sdk";
import pageTips from "../../components/pageTips";
import httpConfig from "../../config/http";
import { Toast } from "mint-ui";

export default {
  name: "hotList",
  components: { pageTips },
  data() {
    return {
      list: [],
      isLoading: true, //加载状态
      tipsType: "loading", //页面空白type
      shareImg: "", //分享图片
      rootUserId: "",
      isShareImgCanvasComplete: false, //是否生成分享图完成
    };
  },
  async created() {
    document.title = "爆款商品";
    sessionStorage.removeItem("activeIndex");
    var sessionId = utils.getQueryString("session_id");
    console.log("sessionId==", sessionId);
    new Promise((resolve) => {
      if (!sessionId) {
        console.log(222);
        utils.wxAuth().then(() => {
          resolve();
        });
      } else {
        sessionStorage.setItem("sessionId", sessionId);
        localStorage.setItem("session_id", sessionId);
        resolve();
      }
    }).then(() => {
      //获取地址上的rootUserId
      this.rootUserId = utils.getUrlParam("rootUserId") || "";
      //设置子页面返回首页的url地址
      sessionStorage.setItem("returnUrl", encodeURIComponent(location.href));
      //设置埋点的rootUserId，子页面使用
      sessionStorage.setItem("rootUserId", this.rootUserId);
      //用户访问开始时间
      if (!utils.getSessionStorage("accessStartTime")) {
        sessionStorage.setItem("accessStartTime", new Date().getTime());
      }
      this.getGoodsList();
    });
    // 配置js-sdk
    utils.setJsSdk().then(() => {
      this.shareWx();
    });
  },
  methods: {
    //加载优化
    setHashParms() {
      // 增加activeIndex标识用于小程序返回点击2次问题
      if (!utils.isWX()) {
        location.hash =
          "activeIndex=" +
          (!!utils.getSessionStorage("activeIndex")
            ? utils.getSessionStorage("activeIndex")
            : 0);
      }
    },
    //添加页面历史记录，监听popstate事件
    historyPushState() {
      //（小程序返回需点击两次问题）
      history.pushState({ page: 1 }, null, window.location.href);
      window.addEventListener("popstate", function () {
        console.log(utils.getHashParam("activeIndex"), history);
        if (!utils.getHashParam("activeIndex") || !history.state) {
          wx.miniProgram.navigateBack();
        }
      });
    },
    /**
     * 获取爆款商品列表
     */
    async getGoodsList() {
      this.list = [];
      let result = await api.request("getGoodsList", {
        businessId: this.$route.query.businessId,
        show: 1,
      });
      if (result.status === 0) {
        console.log(11111111);
        let _list = result.data.list.map((item) => {
          if (result.data.list.length > 1) {
            item.name = this.getStrLengthTxt(item.name, 40);
          }
          //把价格拆分成整数部分与小数部分
          let price_arr = (item.realPrice + "").split(".");
          let price_integer = price_arr[0];
          let price_decimals =
            price_arr.length < 2
              ? "00"
              : price_arr[1].length < 2
              ? price_arr[1] + "0"
              : price_arr[1];
          item.price_arr = {
            integer: price_integer,
            decimals: price_decimals,
          };
          return item;
        });
        this.list = _list;
        if(_list.length > 0){
          //浏览埋点
          utils.behaviorGatherFn({
            "rootUserId": this.rootUserId,
            "relationId": String(this.list[0].code),
            "clientType": "h5",
            "extType": "view",
            "indexType": "hot_goods",
            "businessId": this.list[0].businessId,
            "extName": this.list[0].name 
          });
        }
      }
      this.hiddenLoading();
      if (this.list.length > 0) {
        // 生成分享截图
        // this.$nextTick(() => {
        //   // 生成分享截图
        //   this.sharePhoto();
        // });
      } else {
        if (result.status === 0) {
          this.tipsType = "empty-minapp";
        } else if (result.status != 401) {
          Toast(result.message || "请求失败");
          this.tipsType = "error-data";
        }
        wx.hideMenuItems({
          menuList: [
            "menuItem:share:appMessage",
            "menuItem:share:timeline",
            "menuItem:share:qq",
            "menuItem:share:weiboApp",
            "menuItem:share:facebook",
            "menuItem:share:QZone",
          ], // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
        });
      }
      // 优化下次加载
      await this.setHashParms();
      // 记录pages
      await this.historyPushState();
    },
    /**
     * 跳转到商品详情
     */
    async goGoodsDetail(code, pic) {
      // if (!this.isShareImgCanvasComplete) {
      //   Toast("请等待，正在生成海报！");
      //   return;
      // }
      //获取分享图
      //let shareImg = this.shareImg || this.data.list[0].thumbImage;
      let shareImg = pic;
      window.location.href = `${
        httpConfig.urlHost
      }goods-detail?id=${code}&rootUserId=${
        this.rootUserId || ""
      }&sourceType=10&sourceId=${
        this.$route.query.businessId
      }&orginType=1&session_id=${encodeURIComponent(
        localStorage.getItem("session_id")
      )}&shareImg=${encodeURIComponent(shareImg)}`;
    },
    /**
     * 生成分享截图
     */
    sharePhoto() {
      setTimeout(this.toImage, 100);
    },
    /**
     * 绘制截图
     */
    toImage() {
      console.log("开始截图");
      // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
      (window.html2canvas || html2canvas)(this.$refs.pageBody, {
        x: 0,
        y: 0,
        width: this.$refs.pageBody.clientWidth,
        height: this.$refs.pageBody.clientWidth * 0.8,
        backgroundColor: null,
        useCORS: true, // 如果截图的内容里有图片,可能会有跨域的情况,加上这个参数,解决文件跨域问题
        logging: true,
      })
        .then((canvas) => {
          this.shareImgData = canvas.toDataURL("image/png");
          this.sendUrl();
        })
        .catch(() => {
          this.isShareImgCanvasComplete = true;
        });
    },
    /**
     * 上传base64图片，换取图片地址
     */
    async sendUrl() {
      let result = await api.request("uploadImageForBase64", {
        base64Files: [{ content: this.shareImgData }],
      });
      if (result.status === 0) {
        this.shareImg = result.data[0].file;
        this.isShareImgCanvasComplete = true;
        return this.shareImg;
      } else {
        Toast(result.message || "生成分享图失败");
        this.isShareImgCanvasComplete = true;
        return "";
      }
    },
    /**
     * 获取指定长度的字符
     */
    getStrLengthTxt(str, length = 40) {
      //获取字符串的字节数
      let count = 0; //初始化字节数递加变量并获取字符串参数的字符个数
      let txt = "";
      if (str) {
        //如果存在字符串，则执行
        let len = str.length;
        for (let i = 0; i < len; i++) {
          //遍历字符串，枚举每个字符
          if (str.charCodeAt(i) > 255) {
            //字符编码大于255，说明是双字节字符(即是中文)
            count += 2; //则累加2个
            txt = txt + str[i];
          } else {
            count++; //否则递加一次
            txt = txt + str[i];
          }
          if (count >= length) {
            if (len > i + 1) {
              txt = txt + "...";
            }
            break;
          }
        }
        return txt;
      } else {
        return "";
      }
    },
    /**
     * 隐藏加载
     */
    hiddenLoading() {
      let timer = setTimeout(() => {
        this.isLoading = false;
        clearTimeout(timer);
      }, 200);
    },
    //分享
    shareWx() {
      let that = this;
      wx.ready(function () {
        //分享链接
        var shareUrl = window.location.href + "&rootUserId=" + this.rootUserId;
        let firstGoodsItem = that.list.length > 0 ? that.list[0] : "";
        let shareImg = that.shareImg || "";
        let shareTitle = "爆款商品";
        if (firstGoodsItem) {
          shareImg = firstGoodsItem.thumbImage;
          shareTitle = "【" + firstGoodsItem.name + "】爆款商品";
        }
        //分享参数
        var options = {
          // 分享标题
          title: shareTitle,
          // 分享描述
          desc: "商家精心挑选的商品，快来看看吧",
          // 分享图标
          link: shareUrl,
          // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareImg + "@c_1,w_320,h_320",
        };
        //分享朋友
        wx.onMenuShareAppMessage({
          title: options.title,
          desc: options.desc,
          link: options.link,
          imgUrl: options.imgUrl,
          type: "",
          dataUrl: "",
          success: function () {
            console.log("分享朋友");
          },
          cancel: function () {
            console.log("取消分享朋友");
          },
        });
        //分享朋友圈
        wx.onMenuShareTimeline({
          title: options.title,
          link: options.link,
          imgUrl: options.imgUrl,
          success: function () {
            console.log("分享朋友圈");
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
            console.log("取消分享朋友圈");
          },
        });
      });
    },
    //跳转分享
    jumpForwarding(){
      wx.miniProgram.navigateTo({
        url: "/pages-user/share-activity/share-activity?orginType=hotGoods&rootUserId=" + this.rootUserId,
    });
    }
  },
};
</script>

<style scoped>
.page-body {
  max-height: 100vh;
  overflow: scroll;
}
.empty-cell {
  width: 100vw;
  height: 100vh;
  display: flex;
}
.goods-list {
  max-width: 750px !important;
  background: linear-gradient(315deg, #6700d0 0%, #7dacfd 100%);
  margin: 0 auto;
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-flow: column;
}
.bg-top {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.bg-bottom {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
}

.single-info {
  width: 66vw;
  height: 98vw;
  border: 1vw solid #a59cfc;
  background: linear-gradient(141deg, #ffffff 0%, #f6d9ff 100%);
  border-radius: 2.7vw;
  position: absolute;
  z-index: 2;
  left: 17vw;
  top: 45vw;
  padding: 1.32vw;
  box-sizing: border-box;
}
.goods-item {
  width: 91.6vw;
  height: 47vw;
  border: 0.5vw solid #a59cfc;
  background: linear-gradient(141deg, #ffffff 0%, #f6d9ff 100%);
  border-radius: 2.7vw;
  display: flex;
  flex-flow: column;
  position: relative;
  padding: 3.5vw 3.5vw 3.5vw 44.7vw;
  box-sizing: border-box;
}
.single-info .pic {
  width: 63.36vw;
  height: 63.36vw;
}
.single-info .pic img {
  width: 61.36vw;
  height: 61.36vw;
  object-fit: cover;
}
.goods-item .name,
.single-info .name {
  /* font-family: msyh; */
  font-size: 3.7vw;
  line-height: 5.3vw;
  color: #333333;
  margin-top: 3.96vw;
}
.single-info .name {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.single-info .price-but {
  position: absolute;
  width: 100%;
  bottom: 0;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: end;
  position: absolute;
  bottom: 4vw;
  left: 0;
  box-sizing: border-box;
  padding-right: 4%;
  padding-left: 6%;
}

.single-info .price-but .price,
.goods-item .price {
  color: #f0142d;
  /* font-family: msyh; */
  font-family: Microsoft YaHei;
  line-height: 1 !important;
  display: inline-block;
  display: flex;
  flex-flow: row nowrap;
  font-weight: bold;
  vertical-align: bottom;
}

.goods-item .price {
  /* margin-top: 2vw; */
  transform: translateY(2vw);
}

.single-info .price-but .but,
.goods-item .but {
  width: 23.3vw;
  height: 8.8vw;
  background: #fe5959;
  border-radius: 1vw;
  font-size: 4vw;
  line-height: 8.8vw;
  text-align: center;
  color: #ffffff;
}

.goods-item .but {
  position: absolute;
  width: 21.3vw;
  bottom: 4.5vw;
  right: 5vw;
}
.single-info .hot-icon,
.goods-item .hot-icon {
  width: 12.7vw;
  position: absolute;
  top: -1vw;
  left: 5vw;
  z-index: 3;
}

.goods-item .hot-icon {
  top: -0.5vw;
}
.list {
  display: flex;
  flex-flow: column;
  align-items: center;
  margin-top: 45vw;
  z-index: 2;
  padding-bottom: 30vw;
}

.goods-item:nth-child(n + 2) {
  margin-top: 2.7vw;
}

.goods-item .pic {
  width: 40vw;
  height: 40vw;
  position: absolute;
  left: 2.7vw;
  top: 50%;
  transform: translateY(-50%);
}

.goods-item .pic img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.forwarding{
  position: fixed;
  bottom: 0;
  z-index: 9999;
  width: 100vw;
  background-color: #fff;
  height: 14vw;
  text-align: center;
  line-height: 13vw;
}

.forwarding span{
  width: 92vw;
  background-color: #2E6AF8FF;
  display: inline-block;
  margin: 0 auto;
  height: 9vw;
  line-height: 9vw;
  color: #fff;
  font-size: 3.6vw;
  border-radius: 1vw;
}

@media screen and (min-height: 700px) {
  .single-info {
    top: 51.9vw;
  }
  .list {
    margin-top: 51.9vw;
  }
}
</style>